define([
	"dojo/_base/event",
	"dojo/_base/lang",
	"dojo/keys",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/def/Action",
	"csi/locale",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPlugin",
	"dojo/text!csi/templates/find.html",
	"dijit/form/ValidationTextBox"
], function(event, lang, keys, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, Action, locale, PluginFactory, ToolbarPlugin, template) {

	return PluginFactory.declare("find", [_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin, ToolbarPlugin], {
		// html template for plugin
		templateString: template,

		// connection points
		innerNode: null,
		textNode: null,

		/** @property {string} placeholder - placeholder for text box */
		placeHolder: "",

		// String: value of widget
		value: "",

		// Boolean: necessary to focus text node after filtering
		_bFocus: false,

		/**
		 * @override
		 * Set appearance based on action
		 */
		postMixInProperties: function() {
			this.placeHolder = this.placeHolder || locale.resource("Search");

			if (!this.defAction) {
				this.defAction = lang.mixin(new Action(), {m_id: "ViewFind"});
				this.defAction.resolve();
			}

			this._mixinActionProperties();
			this.inherited(arguments);
		},

		enablePlugin: function(/*Context?*/ctx) {
			// summary: actions do not edit, so enable or disable based on if context is present
			this._setDisabled(this.textNode, !ctx);

			if (ctx && this._bFocus) {
				this.textNode.focus();
				this._bFocus = false;
			}
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: find only makes sense to use if client-side store
			return !!ctx.view.findAttributes;
		},

		_onInputText: function(/*Event*/evt) {
			// summary: if ENTER key pressed then initiate search and refocus on widget when done
			if (evt.keyCode == keys.ENTER) {
				const value = this.textNode.get("value").trim();
				event.stop(evt);
				this._bFocus = true;
				this._set("value", value);
				this.onChange(value);
			}
		},

		/**
		 * Callback when user click on "Start Search" button
		 */
		_onSearchClick: function() {
			const value = this.textNode.get("value").trim();
			this._set("value", value);
			this.onChange(value);
		},

		/**
		 * Forward placeholder to text box
		 * @param {boolean} value
		 */
		_setPlaceHolderAttr: function(value) {
			this._set("placeHolder", value);
			this.textNode.set("placeHolder", value);
		},

		_setValueAttr: function(/*String*/value) {
			// summary: set filter value
			if (value != this.get("value")) {
				this.textNode.set("value", value, false);
				this._set("value", value);
				this.onChange(value);
			}
		}
	});
});